import Page from 'components/Page';
import DropDownTag from 'components/marketing-report/DropDownTag';
import React, { forwardRef, useRef, useState } from 'react'
import StarRatings from 'react-star-ratings';
import { Progress } from 'reactstrap';
import { formatPhone } from 'utils/formatPhone';
import useDebounce from 'utils/useDebounce';
const statusOpts = [
  { label: 'Lasted', value: 'lasted' },
  { label: 'Highest rated', value: 'highest_rated' },
];

const starOpts = [
  { label: 'All Star', value: 'all_star' },
  { label: '5 Stars', value: '5_stars' },
  { label: '4 Stars', value: '4_stars' },
  { label: '3 Stars', value: '3_stars' },
  { label: '2 Stars', value: '2_stars' },
  { label: '1 Star', value: '1_star' },
];

const ReviewComment = () => {
  const divRef = useRef(null);
  const [statusFilter, setStatusFilter] = useState(statusOpts[0].value);
  const [starFilter, setStarFilter] = useState(starOpts[0].value);
  return (
    <Page title={'Reviews & Comments'} className="review_comment_kit">
      <RatingBox />
      <div className="review_comment_kit_review">
        <div className="review_label">Review</div>
        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
          <DropDownTag maxHeightRatio={0.35} blue onChange={setStatusFilter} value={statusFilter} options={statusOpts} />
          <DropDownTag autoHeight onChange={setStarFilter} value={starFilter} options={starOpts} />
        </div>
        <div ref={divRef} style={{ marginTop: '8px', marginBottom: '16px' }} />
        <div style={{ minHeight: '100vh' }}>
          <InputNameDebounce onFocus={() => divRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })} />
          <div className="review_comment_kit_reviews">
            {mockData.map(o => (
              <ReviewItem key={o.id} data={o} />
            ))}
          </div>
        </div>
      </div>
    </Page>
  )
}

export default ReviewComment;


const ReviewItem = ({ data }) => {
  return (
    <div className='review_comment_kit_review_item'>
      <div className="review_comment_kit_review_item_customer_info">
        <div className="review_comment_kit_review_item_customer_name">
          {data.customerName || 'Unknown'}
        </div>
        <div className="d-flex align-items-center">
          <IconCalling />
          <div className="ml-1 review_comment_kit_review_item_customer_phone">
            {formatPhone(data.phone)}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center" style={{ gap: '8px' }}>
        <StarRatings
          rating={data.star}
          starRatedColor="#FFC31F"
          numberOfStars={5}
          starDimension={'12px'}
          starSpacing='0px'
          name='rating'
        />
        <div className="review_comment_kit_review_item_create_date">{data.createDate}</div>
      </div>
      <div className="d-flex align-items-center mb-2" style={{ gap: '8px' }}>
        <div className="review_comment_kit_review_item_review_id">
          #{data.id}
        </div>
        <div className="review_comment_kit_review_item_staff_label">
          Staff:
        </div>
        <div className="d-flex align-items-center" style={{ gap: '4px' }}>
          <div style={{ backgroundImage: `url(${data.staffAvatar})` }} className="review_comment_kit_review_item_staff_avatar" />
          <div className="review_comment_kit_review_item_staff_name">
            {data.staffName}
          </div>
        </div>
      </div>
      <div className="review_comment_kit_review_item_comment">
        {data.comment}
      </div>
      <div className="review_comment_kit_review_item_services text-ellipsis">
        Services: {data.services.map(o => o.name).join(', ')}
      </div>
    </div>
  );
};


const InputNameDebounce = ({ defaultValue, onDebounce, disabled, onFocus }) => {
  const inputRef = useRef(null);
  const [text, onChange] = useDebounce(defaultValue, onDebounce);

  return (
    <div className="input_kit input_search">
      <div className="prefix_icon"><SearchIcon /></div>
      <input onFocus={onFocus} placeholder='Customer Name' className='none-disabled-style' ref={inputRef} type="text" value={text} onChange={onChange} disabled={disabled} />
    </div>
  )
};

const RatingBox = () => {
  return (
    <div className='review_comment_kit_rating'>
      <div className="review_comment_kit_rating_total_box">
        <div className="total_text">4</div>
        <StarRatings
          rating={4.5}
          starRatedColor="#FFC31F"
          numberOfStars={5}
          starDimension={'14px'}
          starSpacing='0px'
          name='rating'
        />
        <div className="counting_text">{855} Ratings</div>
      </div>
      <div className="divider" style={{ marginLeft: '16px', marginRight: '24px' }} />
      <div className="review_comment_kit_rating_star_details">
        <StarItem label={'5'} percent={90} value={117} />
        <StarItem label={'4'} percent={50} value={117} />
        <StarItem label={'3'} percent={40} value={117} />
        <StarItem label={'2'} percent={30} value={117} />
        <StarItem label={'1'} percent={10} value={117} />
      </div>
    </div>
  )
};

const StarItem = ({ percent, label, value }) => (
  <div className="review_comment_kit_rating_star_detail_item">
    <div className="review_comment_kit_rating_star_detail_item_label">{label}</div>
    <Star />
    <Progress value={percent} />
    <div className="review_comment_kit_rating_star_detail_item_counting">{value}</div>
  </div>
);

const Star = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path d="M6 2.11803L6.87156 4.80041L6.98381 5.1459H7.34708H10.1675L7.88573 6.8037L7.59184 7.01722L7.7041 7.36271L8.57565 10.0451L6.29389 8.38729L6 8.17376L5.70611 8.38729L3.42435 10.0451L4.2959 7.36271L4.40816 7.01722L4.11426 6.8037L1.8325 5.1459H4.65292H5.01619L5.12844 4.80041L6 2.11803Z" fill="#FFC31F" stroke="#FFC31F" />
  </svg>
);

const SearchIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="interactive-button/Search">
      <path id="Ellipse (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z" fill="#686868" />
      <path id="Line (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M17.487 17.9557C17.7796 17.6624 18.2544 17.6618 18.5477 17.9543L22.0717 21.4692C22.365 21.7617 22.3656 22.2366 22.0731 22.5299C21.7806 22.8231 21.3057 22.8238 21.0125 22.5312L17.4884 19.0164C17.1952 18.7239 17.1945 18.249 17.487 17.9557Z" fill="#686868" />
    </g>
  </svg>
);

const IconCalling = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path d="M13.5177 6.76643C13.6742 6.65423 13.7658 6.45768 13.7477 6.26537C13.6811 5.67121 13.5222 5.08739 13.2762 4.5423C12.7017 3.26299 11.6301 2.21498 10.337 1.67042C9.83732 1.45212 9.3034 1.32374 8.76418 1.25L8.63096 1.25C8.39718 1.27546 8.18727 1.45557 8.14004 1.68819C8.08511 1.90915 8.18462 2.15504 8.37409 2.27971C8.52747 2.38925 8.72437 2.38315 8.90243 2.41631C9.76434 2.56777 10.5817 2.97254 11.218 3.5736C11.986 4.28607 12.4889 5.27651 12.6122 6.31656C12.6295 6.50967 12.7266 6.70171 12.9004 6.79773C13.088 6.91099 13.3431 6.89906 13.5177 6.76643Z" fill="#686868" />
    <path d="M12.8886 12.9634C13.0439 12.7108 13.1224 12.4153 13.1244 12.1195C13.1252 11.5851 13.1252 11.0505 13.1244 10.5158C13.1229 10.2559 13.0693 9.9949 12.9513 9.76243C12.7258 9.29697 12.2635 8.96046 11.7545 8.87932C11.3206 8.81599 10.8895 8.72468 10.4757 8.57716C10.3252 8.52654 10.1754 8.46906 10.0177 8.44413C9.69657 8.38894 9.35942 8.43472 9.06441 8.57334C8.72066 8.72315 8.48608 9.0271 8.21849 9.27687C7.21897 8.64761 6.36874 7.78689 5.73226 6.79163C5.94425 6.56983 6.18747 6.3717 6.34817 6.10641C6.60764 5.69818 6.6579 5.17015 6.49771 4.71512C6.35858 4.31757 6.23545 3.91239 6.17224 3.495C6.13796 3.26431 6.10293 3.02827 5.99934 2.81666C5.75308 2.26904 5.18135 1.89286 4.58271 1.87658C4.01529 1.87378 3.44762 1.87658 2.8802 1.87505C2.43134 1.87124 1.98503 2.06632 1.6819 2.398C1.43487 2.66125 1.28382 3.01022 1.25564 3.36987C1.23863 3.53214 1.26351 3.69467 1.28534 3.85516C1.56613 6.17483 2.60931 8.38309 4.17548 10.1088C5.29306 11.3394 6.69548 12.298 8.22205 12.9456C9.05934 13.2872 9.9342 13.5377 10.8289 13.672C11.0987 13.7028 11.3681 13.7717 11.6415 13.7432C12.1495 13.7018 12.6278 13.4022 12.8886 12.9634ZM12.0353 12.2144C11.9977 12.4634 11.7644 12.6651 11.5131 12.6663C9.14921 12.4377 6.89147 11.3333 5.22527 9.64288C3.68829 8.06668 2.65501 5.99348 2.36914 3.80506C2.34833 3.63769 2.29653 3.45889 2.36991 3.29687C2.44835 3.09237 2.66339 2.95197 2.88147 2.9596C3.43162 2.95858 3.98152 2.96036 4.53168 2.95858C4.74443 2.96469 4.95565 3.09924 5.02928 3.30323C5.08031 3.44795 5.08894 3.6031 5.11712 3.75292C5.17449 4.08535 5.25878 4.41244 5.36084 4.73369C5.40425 4.86544 5.45401 4.99541 5.49057 5.1292C5.54135 5.31462 5.47509 5.52191 5.33672 5.6529C5.11356 5.87826 4.88761 6.10081 4.66547 6.32718C4.5068 6.4859 4.46465 6.74457 4.56265 6.94602C5.15368 7.98783 5.94375 8.91773 6.88512 9.65789C7.07198 9.8138 7.2766 9.94607 7.47234 10.0903C7.64067 10.2035 7.81762 10.3032 7.98899 10.4118C8.14131 10.513 8.34441 10.5351 8.51223 10.4614C8.62038 10.4169 8.70137 10.3296 8.78185 10.2482C8.97682 10.0537 9.168 9.85552 9.36399 9.66196C9.47036 9.56251 9.61482 9.49867 9.76182 9.50782C9.87961 9.50833 9.98777 9.56022 10.0982 9.59379C10.5402 9.74844 10.9967 9.86391 11.4605 9.92928C11.5803 9.95014 11.707 9.96921 11.8071 10.044C11.9594 10.1473 12.0462 10.3322 12.0399 10.5148C12.0366 11.0812 12.0457 11.6482 12.0353 12.2144Z" fill="#686868" />
    <path d="M11.8565 6.39419C11.8802 6.29836 11.8811 6.1981 11.8595 6.10197C11.7096 5.36522 11.3388 4.67372 10.7997 4.14873C10.2678 3.62168 9.57318 3.2641 8.8369 3.12982C8.67161 3.10971 8.49626 3.15259 8.36586 3.25788C8.20471 3.38329 8.11127 3.59062 8.12664 3.7944C8.13965 4.02126 8.28573 4.23598 8.49449 4.32649C8.63553 4.38801 8.79166 4.39866 8.93537 4.45219C9.76035 4.71365 10.423 5.43354 10.6049 6.28121C10.6368 6.44447 10.7004 6.6101 10.8314 6.71953C11.0037 6.87097 11.2622 6.91888 11.4754 6.83163C11.6643 6.76005 11.811 6.59058 11.8565 6.39419Z" fill="#686868" />
  </svg>
);


const mockData = [
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15755,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15755,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15753,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15752,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15750,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
  {
    customerName: 'Anne Hathaway',
    phone: '3002565874',
    star: 5,
    createDate: '02-24-2023 09:30AM',
    id: 15749,
    staffName: 'Mia',
    staffAvatar: 'https://s3-alpha-sig.figma.com/img/ed9f/cc05/40746feeb359ce6f66316522d727dc34?Expires=1711324800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=olrSbPT3vi3HAMVruoBgOxm9zhw19oRbNYTu46RBF5wSoexUPpwKNwIn6mL185kkFT4Cv8IfNYYFmQdM~I8jVcUuWDh98rBajCoFTIvty56eErPEkDkgA85T3Vs7WD4v-2zL78BlyxNFtImIpiCIEh~bUtG0hY9XgD-J2nZb-GK5-xIi9cjjxDMoBbJeQcJSczOeTOSyx~SxvjcsdmM0EOv67DAJhWioHXu-i7Ja7DxuBb9ml3p5Jh3~dqTyln5NMb21MSJx4yatGbv332oM9awMFtbVfXtkm7-zqYxZ6qbRor6xcfaZAxtANwkzAlAbeM~yoznu5N1u7LBJ3b9SZA__',
    comment: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es Excepteur sint occaecat cupidatat non proident",
    services: [
      { id: 1, name: 'Full Set', duration: 50 },
      { id: 2, name: 'Manicure', duration: 25 },
    ]
  },
];

